module.exports = __webpack_public_path__ + "static/img/banner-bimbel-snbt-2023.65f65e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banners/banner-bimbel-snbt-2023.jpg
// module id = vvyG
// module chunks = 1